import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {filter} from 'rxjs';
import {FileDto} from '|api/document';
import {FileDetailService} from '|shared';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { CrossReferenceTableComponent } from '../../../document-shared/components/cross-reference-table/cross-reference-table.component';


@Component({
  selector: 'icz-file-detail-related-objects',
  templateUrl: './file-detail-related-objects.component.html',
  styleUrls: ['./file-detail-related-objects.component.scss'],
  imports: [CrossReferenceTableComponent]
})
export class FileDetailRelatedObjectsComponent implements OnInit {

  private fileDetailService = inject(FileDetailService);
  private destroyRef = inject(DestroyRef);

  file!: FileDto;

  ngOnInit() {
    this.fileDetailService.object$.pipe(
      filter(Boolean),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(file => {
      if (file) {
        this.file = file as FileDto;
      }
    });
  }

  onCrossReferenceCountChanged() {
    this.fileDetailService.relatedObjectsChanged.emit();
  }

}
